export default __webpack_public_path__ + "static/ilpapps-intro-ccb4e269e7185ef116295058c7db1139.mp4";